export const storageKeys = {
  AUTH: 'AUTH',
  USER: 'USER',
  LOCALE_ID: 'LOCALE_ID',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
};
